module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product pmt",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Wsparcie w przygotowaniu Wniosku i SW do EIC\n          Accelerator Pilot\n        ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Support in preparation of application and FS\n          for EIC Accelerator Pilot\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n         „Wsparcie Bioseco S.A. w przygotowaniu wniosku oraz studium wykonalności w konkursie EIC Accelerator Pilot”\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nCelem projektu jest zwiększenie innowacyjności i umiędzynarodowienia Spółki poprzez udział w europejskim programie Horyzont 2020 – konkurs EIC Accelerator Pilot.\n ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nRealizacja projektu pozwoliła na przygotowanie wniosku w ramach programu EIC Accelerator Pilot, opracowanie studium wykonalności, poszukiwania partnerów do projektu, a także udział w panelu eksperckim.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nProgram Operacyjny Inteligentny Rozwój 2014-2020 Działanie: 2.3 Proinnowacyjne usługi dla przedsiębiorstw\nPoddziałanie: 2.3.6 Granty na Eurogranty\n                  "), _c('br'), _c('br'), _vm._v("\n                  Wartość projektu:"), _c('br'), _vm._v("280 060,00 PLN"), _c('br'), _c('br'), _vm._v("\n                  Wartość dofinansowania:"), _c('br'), _vm._v("280 060,00 PLN"), _c('br'), _c('br'), _vm._v("\n                  Okres realizacji projektu:"), _c('br'), _vm._v("02.03.2020 – 31.03.2021"), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n         Support of Bioseco S.A. in the preparation of the application and the feasibility study in the EIC Accelerator Pilot competition\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nThe aim of the project is to increase the company's innovation and internationalization by participating in the European program Horizon 2020 - the EIC Accelerator Pilot competition.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nThe implementation of the project allowed for the preparation of the application under the EIC Accelerator Pilot program, development of the feasibility study, search for partners for the project, as well as participation in the expert panel.\n               ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nOperational Programme Smart Growth 2014-2020; Measure: 2.3; Pro-innovative services for enterprises; Sub-measure: 2.3.6 Grants for Eurogrants\n                  "), _c('br'), _c('br'), _vm._v("\n                  Project value:"), _c('br'), _vm._v("280 060,00 PLN"), _c('br'), _c('br'), _vm._v("\n                  Co-financing value:"), _c('br'), _vm._v("280 060,00 PLN"), _c('br'), _c('br'), _vm._v("\n                  Project implementation period:"), _c('br'), _vm._v("02.03.2020 – 31.03.2021"), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19f7245d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/EIC.vue
// module id = 280
// module chunks = 0